module.exports = __webpack_public_path__ + "static/media/2_move_slides.d64bb6d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/2_move_slides.jpg
// module id = 308
// module chunks = 0